import React from 'react';
import c from './userInitials.module.scss';

const UserInitialsIcon = ({ avatarSrc }) => {
  // render

  return (
    <div className={[c.circle, c.circleSmall].join(' ')}>
      {/* Display avatar */}
      <img src={avatarSrc} alt="" id="avatarImg" />
    </div>
  );
};

export default UserInitialsIcon;
